<template lang="pug">
//- может появиться на странице два раза, чтобы не было дублей ID, нужен Math.random()
div(:id="'listRadioVue'+Math.random()")
  .radio-labeled.flex(v-for="(item, index) in list", :key="item.ID", :class="{ 'mt-2': index > 0 }", :data-qa="'list-radio-item-' + item.ID")
    input(type="radio", class="checkout-radio cursor-pointer h-min", :value="item.ID", :name="item.ID", :id="item.ID", :checked="activeRadio == item.ID", @change="activeRadio = item.ID", :data-qa="'list-radio-input-' + item.ID")
    label.radio-label(class="", :class="{ 'font-medium active': activeRadio == item.ID }", :for="item.ID", :data-label="label(item)", :data-price="item.PRICE > 0 ? formatMoney(item.PRICE) : $t('basket_free')", :data-qa="'list-radio-label-' + item.ID")
      | {{ item.NAME ? item.NAME : item.ID }}
      template(v-if="!noPrice") {{ priceAndTransitLabel(item) }}
      template(v-if="citiesForNoty.includes(curruntCity) && item.ID === 'I_COURIER_1DAY'")
        .purpleHolder.px-4.pt-3.pb-3.mt-2.radio-helper
          .radio-helper__container
            ExclamationAlertIcon.radio-helper__icon(color="#726CE7", topPosition="0")
            span.radio-helper__text {{ $t('kazan_1day_info') }}
      template(v-if="showKzNotification(item)")
        .grayHolder.px-4.pt-2.pb-1.mt-2.radio-helper
          .flex.justify-start.basket-row
            .icon.mr-1
              ExclamationAlertIcon(color="#333F48BF", topPosition="2")
            p(class="text-[12px] text-[#333F48BF]") {{ $t('checkout_kz_time_notify') }}

</template>

<script>
import { declOfNumGlobal } from '@/utils/delivery.js'

export default {
  name: 'ListRadio',
  props: {
    list: Array,
    selected: { type: String, default: '' },
    noPrice: {
      type: Boolean,
      default: false,
    },
    city: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      citiesForNoty: [
        'Уфа',
        'Белгород',
        'Махачкала',
        'Иркутск',
        'Дзержинск',
        'Пивовариха',
        'Молодежный',
        'Новолисиха',
        'Марково',
        'Смоленщина',
        'Мамоны',
        'Шелехов',
        'Селиваниха',
        'Калуга',
        'Краснодар',
        'Сочи',
        'Адлер',
        'Санкт-Петербург',
        'Нижний Новгород',
        'Новосибирск',
        'Пермь',
        'Ростов-на-Дону',
        'Казань',
        'Набережные Челны',
        'Томск',
        'Тула',
        'Хабаровск',
        'Челябинск',
        'Москва',
      ],
    }
  },
  computed: {
    getCountry() {
      return this.$store.state.country
    },
    curruntCity() {
      return this.$store.state.addressInfo.PROFILE.CITY || this.city
    },
    activeRadio: {
      get() {
        return this.syncActiveRadio()
      },
      set(id) {
        this.$emit('callback', id)
      },
    },
  },

  methods: {
    syncActiveRadio() {
      const ids = this.list.map((i) => i.ID)
      let next = ''

      if (this.selected && ids.includes(this.selected)) {
        // находим соответствия со списком
        next = this.selected // выбран элемент из текущего списка
      } else if (this.list.length) {
        next = this.list[0].ID // берём первый элемент
      } else if (this.getCountry.code === 'DE') {
        next = '' // спец-логика для DE
      }

      return next
    },

    label(item) {
      let label = item.NAME ? item.NAME : item.ID
      if (!this.noPrice) {
        label +=
          ', ' +
          (item.TRANSIT
            ? item.TRANSIT +
              ' ' +
              this.declOfNum(item.TRANSIT, this.$t('declDays')) +
              ', '
            : '')
      }
      return label
    },
    declOfNum(number, titles) {
      return declOfNumGlobal(number, titles)
    },
    callback(id) {
      console.log('callback in List', id)
      this.activeRadio = id
    },
    formatMoney(value) {
      return new Intl.NumberFormat(this.getCountry.code, {
        style: 'currency',
        currency: this.$store.state.currency,
        currencyDisplay: this.getCountry.code === 'NO' ? 'code' : 'symbol',
        numberingSystem: 'latn',
      }).format(value)
    },
    priceAndTransitLabel(item) {
      let transitInfo = item.TRANSIT
        ? `, ${item.TRANSIT} ${this.declOfNum(item.TRANSIT, this.$t('declDays'))}, `
        : ''
      // обработка ответа сервера "день-в-день" -- без пробела
      if (item.TRANSIT.toLowerCase().includes('день-в-день'))
        transitInfo = `, ${item.TRANSIT}${this.declOfNum(item.TRANSIT, this.$t('declDays'))}, `

      let priceInfo =
        item.PRICE > 0 ? this.formatMoney(item.PRICE) : this.$t('basket_free')
      return `${transitInfo}${priceInfo}`
    },
    showKzNotification(item) {
      if (this.getCountry.code !== 'KZ') return false

      const minTransitDays = +(item.TRANSIT.split('-')[0] || item.TRANSIT)
      return minTransitDays > 5
    },
  },
}
</script>

<style lang="scss" scoped>
input[type='radio'] {
  -webkit-appearance: none;
  -moz-appearance: none;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  position: relative;
  top: 1px;

  @media (max-width: 480px) {
    min-width: 24px;
    min-height: 24px;
    -webkit-appearance: radio;
    -moz-appearance: radio;
    -ms-appearance: auto;
    -o-appearance: auto;
    appearance: auto;
    visibility: hidden;
  }
}
input[type='radio']:focus {
  outline: none;
}
input[type='radio']:after {
  width: 24px;
  height: 24px;
  border-radius: 16px;
  position: relative;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 2px solid #bec1c6;

  @media (max-width: 480px) {
    position: absolute;
    background-color: white;
  }
}

input[type='radio']:checked:after {
  width: 24px;
  height: 24px;
  border-radius: 15px;
  position: relative;
  background-color: #fff;
  content: '';
  display: inline-block;
  visibility: visible;
  border: 8px solid #f36355;
}
.radio-labeled {
  @media (max-width: 480px) {
    flex-direction: row-reverse;
    gap: 20px;
  }
}
.radio-labeled:not(:last-child) {
  @media (max-width: 480px) {
    padding-bottom: 11px;
    margin-bottom: 12px;
    border-bottom: 1px solid #e5ecf1;
  }
}
.radio-helper {
  max-width: 493px;
  width: 100%;

  @media (max-width: 480px) {
    margin-top: 20px;
    width: 107%;
  }

  &__container {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__text {
    font-weight: 400;
    font-size: 14px;
    line-height: 1.4;
    color: #39444c;
  }

  &__icon {
    min-width: 24px;
    min-height: 24px;
  }
}
.radio-label {
  margin-left: 10px;
  cursor: pointer;
  width: 100%;

  @media (max-width: 480px) {
    margin-left: 0;
  }
}
</style>
